import { useEffect, useState } from "react";

export type Theme = "light" | "dark";

const KEY = "growsoft_theme";

export function getInitialTheme(): Theme {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem(KEY) as Theme | null;
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

// Cor da status bar do PWA Android. Combina com `bg-slate-950` no dark e
// `bg-white` no light — a barra superior do sistema acompanha o tema.
const THEME_COLOR_DARK = "#0f172a";
const THEME_COLOR_LIGHT = "#ffffff";

export function applyTheme(t: Theme) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", t === "dark");
  // Sincroniza a meta theme-color (barra do navegador / status bar do PWA).
  // Em mobile Android, o sistema lê esse valor pra colorir a barra superior.
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", t === "dark" ? THEME_COLOR_DARK : THEME_COLOR_LIGHT);
}

/**
 * Aplica e persiste o tema. Use no nível raiz (App).
 */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => getInitialTheme());

  useEffect(() => {
    applyTheme(theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch {}
  }, [theme]);

  return {
    theme,
    isDark: theme === "dark",
    toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    setTheme,
  };
}
